import { ArrowDropDown } from "@mui/icons-material";
import { useState } from "react";

import { OutlinedButton } from "@/Components/v2/atoms/Button";

import { useGeoEnabled } from "../../../../hooks/useGeoEnabled";
import { QuickSimulateForm } from "./QuickSimulateForm";
import { QuickSimulateGeoForm } from "./QuickSimulateGeoForm";

export interface QuickSimulateButtonProps {
  onSimulationComplete?: () => void;
  onSubmit?: () => void;
  defaultBusinessUnit?: string;
}

export const QuickSimulateButton: React.FC<QuickSimulateButtonProps> = ({
  onSimulationComplete,
  onSubmit,
  defaultBusinessUnit,
}) => {
  const [quickSimulateOpen, setQuickSimulateOpen] = useState(false);
  const geoEnabled = useGeoEnabled();
  const isGeoEnabled = !geoEnabled.isLoading && geoEnabled.isEnabled;

  const handleClick = () => {
    setQuickSimulateOpen(true);
  };

  const handleClose = () => {
    setQuickSimulateOpen(false);
  };

  const onScenarioSubmit = () => {
    if (onSubmit) onSubmit();
    setQuickSimulateOpen(false);
  };

  return (
    <>
      <OutlinedButton
        id="quick-simulate-button"
        aria-controls={quickSimulateOpen ? "quick-simulate-form" : undefined}
        aria-haspopup="true"
        aria-expanded={quickSimulateOpen ? "true" : undefined}
        onClick={handleClick}
        variant="outlined"
        size="large"
        endIcon={<ArrowDropDown />}
      >
        Quick Scenario
      </OutlinedButton>
      {isGeoEnabled ? (
        <QuickSimulateGeoForm
          open={quickSimulateOpen}
          onClose={handleClose}
          onSubmit={onScenarioSubmit}
          onSimulationComplete={onSimulationComplete}
          defaultBusinessUnit={defaultBusinessUnit}
        />
      ) : (
        <QuickSimulateForm
          open={quickSimulateOpen}
          onClose={handleClose}
          onSubmit={onScenarioSubmit}
          onSimulationComplete={onSimulationComplete}
          defaultBusinessUnit={defaultBusinessUnit}
        />
      )}
    </>
  );
};
